import React, { useState, useEffect } from "react";
import Ajv, { ErrorObject } from "ajv";
import Editor from "@monaco-editor/react";
import "./App.css";
import axios from "axios";
import Select from "react-select";

interface SchemaOption {
  label: string;
  value: string;
}

const schemaOptions: SchemaOption[] = [
  { label: "ethdebug/format/type/elementary/uint", value: "uint" },
  { label: "ethdebug/format/type/elementary/address", value: "address" },
  // Add more schema options as needed
];

const ajv = new Ajv();

const App: React.FC = () => {
  const [schema, setSchema] = useState<string>("");
  const [selectedSchema, setSelectedSchema] = useState<string>();
  const [validationErrors, setValidationErrors] = useState<ErrorObject[]>([]);

  useEffect(() => {
    validateSchema();
  }, [schema, selectedSchema]);

  const validateSchema = () => {
    console.log(selectedSchema);
    if (!selectedSchema) {
      // @ts-ignore
      return setValidationErrors([{ message: "Please select a schema" }]);
    }
    try {
      axios
        .get(`../schemas/${selectedSchema}.json`)
        .then((response) => {
          const selectedSchemaContent = response.data;
          const validate = ajv.compile(selectedSchemaContent);
          let isValid;
          try {
            isValid = validate(JSON.parse(schema));
          } catch (e) {
            console.log("failed to parse json");
            //@ts-ignore
            setValidationErrors([{ message: "Must be valid JSON" }]);
          }
          console.log(JSON.parse(schema));

          if (!isValid) {
            setValidationErrors(validate.errors || []);
          } else {
            setValidationErrors([]);
          }
        })
        .catch((error) => {
          console.error("Error loading schema:", error);
        });
    } catch (error) {
      console.error("Error loading schema:", error);
    }
  };

  const getMonacoEditorOptions = () => {
    return {
      automaticLayout: true,
      minimap: {
        enabled: false,
      },
      glyphMargin: true,
      lightbulb: {
        enabled: true,
      },
    };
  };

  const getMonacoEditorDecorations = () => {
    return validationErrors.map((error) => {
      return {
        range: {
          startLineNumber: error.dataPath
            ? parseInt(error.dataPath.split("/")[1], 10)
            : 1,
          startColumn: error.dataPath
            ? parseInt(error.dataPath.split("/")[2], 10)
            : 1,
          endLineNumber: error.dataPath
            ? parseInt(error.dataPath.split("/")[1], 10)
            : 1,
          endColumn: error.dataPath
            ? parseInt(error.dataPath.split("/")[2], 10)
            : 1,
        },
        options: {
          isWholeLine: true,
          className: "validation-error-decoration",
          hoverMessage: {
            value: error.message || "Unknown error",
            isTrusted: true,
          },
        },
      };
    });
  };

  return (
    <div className="App">
      <div className="header">
        <label className="title">
          <b>🪲 EthDebug Playground</b>
        </label>
        <Select
          placeholder="Select Schema"
          className="select"
          options={schemaOptions}
          onChange={(option: SchemaOption) => setSelectedSchema(option.value)}
        />
      </div>
      <div className="editor">
        <Editor
          height="300px"
          defaultLanguage="json"
          onChange={(value) => setSchema(value)}
          options={getMonacoEditorOptions()}
        />
      </div>
      <div className="errors">
        <h3>Validation Errors</h3>
        {validationErrors.length > 0 ? (
          <ul>
            {validationErrors.map((error, index) => (
              <li key={index}> 🛑 {error.message}</li>
            ))}
          </ul>
        ) : (
          <p>No validation errors</p>
        )}
      </div>
    </div>
  );
};

export default App;
